function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath18",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M 0,768 H 1254.055 V 0 H 0 Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath860"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,4000 H 4000 V 0 H 0 Z",
  id: "path858"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath20",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path18",
  d: "M 0,0 V 0 8418.9 H 11905.5 11546.9 9802 9396.25 9080.4 0 V 7784.77 6975.86 4299.58 341.973 0"
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath36",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path34",
  d: "M 11905.5,0 H 0 11905.5 V 8418.9 0"
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath52",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path50",
  d: "M 3680,6348.9 0,7784.77 v 88.57 L 7180.82,8418.9 H 9080.4 L 3680,6348.9"
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath64",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "m 600,4498.9 3080,1850 640,-1750 -3720,-100"
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath76",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path74",
  d: "M 0,4299.58 V 4851.4 L 600,4498.9 0,4299.58"
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath88",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path86",
  d: "M 730,658.902 4320,4598.9 5180,3188.9 730,658.902"
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath100",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path98",
  d: "M 0,341.973 V 1345.82 L 730,658.902 0,341.973"
}));

var _ref11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath112",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path110",
  d: "M 730,658.902 0,1345.82 V 4299.58 L 600,4498.9 730,658.902"
}));

var _ref12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath124",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path122",
  d: "m 730,658.902 v 0 L 600,4498.9 4320,4598.9 730,658.902"
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath136",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path134",
  d: "M 0,7873.34 V 8418.9 H 7180.82 L 0,7873.34"
}));

var _ref14 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath148",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path146",
  d: "m 10880,7648.9 -1078,770 h 1744.9 l -666.9,-770"
}));

var _ref15 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath160",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path158",
  d: "m 11905.5,5953.51 v 0 L 10880,7648.9 l 666.9,770 h 358.6 V 5953.51"
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath172",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path170",
  d: "M 6345.7,0 H 5517.46 L 6100,598.902 6345.7,0"
}));

var _ref17 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath184",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path182",
  d: "m 5180,3188.9 v 0 l -860,1410 860,-1380 v -30"
}));

var _ref18 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath196",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path194",
  d: "m 5180,3218.9 v 0 l -860,1380 1010,-200 -150,-1180 m -860,1380 v 0"
}));

var _ref19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath208",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path206",
  d: "M 600,4498.9 0,4851.4 V 6070.03 L 600,4498.9"
}));

var _ref20 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath220",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path218",
  d: "m 3680,6348.9 v 0 m 0,0 L 0,6975.86 v 808.91 L 3680,6348.9"
}));

var _ref21 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath232",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path230",
  d: "m 600,4498.9 v 0 L 0,6070.03 v 905.83 L 3680,6348.9 600,4498.9"
}));

var _ref22 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath244",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path242",
  d: "M 1738.62,0 H 1388.9 L 730,658.902 1738.62,0"
}));

var _ref23 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath256",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path254",
  d: "m 3680,6348.9 v 0 l 5400.4,2070 h 315.85 L 7910,6678.9 3680,6348.9"
}));

var _ref24 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath268",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path266",
  d: "m 7910,6678.9 1486.25,1740 H 9802 l 1078,-770 -2970,-970"
}));

var _ref25 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath280",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path278",
  d: "m 11905.5,5653.92 v 0 L 7910,6678.9 l 2970,970 1025.5,-1695.39 v -299.59"
}));

var _ref26 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath292",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path290",
  d: "M 5517.46,0 H 4548.75 L 6100,598.902 5517.46,0"
}));

var _ref27 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath304",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path302",
  d: "M 4548.75,0 H 3305.16 L 5180,3188.9 6100,598.902 4548.75,0"
}));

var _ref28 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath316",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path314",
  d: "M 1867.63,0 H 1738.62 L 730,658.902 1867.63,0 M 730,658.902 v 0"
}));

var _ref29 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath328",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path326",
  d: "M 3305.16,0 H 1867.63 L 730,658.902 5180,3188.9 3305.16,0"
}));

var _ref30 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath340",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path338",
  d: "M 6632.36,0 H 6345.7 L 6100,598.902 6632.36,0"
}));

var _ref31 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath352",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path350",
  d: "M 9207.32,0 H 6632.36 L 6100,598.902 9300,588.902 9207.32,0"
}));

var _ref32 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath364",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path362",
  d: "M 9463.48,0 H 9207.32 L 9300,588.902 9463.48,0"
}));

var _ref33 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath376",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path374",
  d: "m 5670,5908.9 -1990,440 4230,330 -2159.09,-742.19 v 84.93 h -19.99 v -91.8 L 5670,5908.9"
}));

var _ref34 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath388",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path386",
  d: "m 5330,4398.9 340,1510 60.92,20.94 V 4753.2 L 5330,4398.9 m 420.91,371.97 V 5936.71 L 7910,6678.9 5750.91,4770.87"
}));

var _ref35 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath400",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path398",
  d: "m 7600,2348.9 4.22,59.01 h 77.84 L 7600,2348.9 m 839.79,603.83 h -796.56 l 59.71,833.96 h 1896.7 L 8439.79,2952.73 M 10211.6,4226.7 H 7734.44 l 23.62,330 h 2912.44 l -458.9,-330 m 645.6,464.18 v 255.81 c 0,27.51 -22.5,50 -50,50 H 7789.56 L 7910,6678.9 11905.5,5653.92 v -209.25 l -1048.3,-753.79"
}));

var _ref36 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath412",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path410",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref37 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath418",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path416",
  d: "m 11179.2,4396.5 h 734.402 v 1056 H 11179.2 Z"
}));

var _ref38 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath430",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path428",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref39 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath436",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path434",
  d: "m 10824,3009.3 h 369.602 V 5106.9 H 10824 Z"
}));

var _ref40 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath448",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path446",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref41 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath454",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path452",
  d: "m 10104,2663.7 h 734.398 V 4756.5 H 10104 Z"
}));

var _ref42 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath466",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path464",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref43 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath472",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path470",
  d: "m 11179.2,3705.3 h 374.402 v 705.602 H 11179.2 Z"
}));

var _ref44 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath484",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path482",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref45 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath490",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path488",
  d: "m 9388.8,1276.5 h 729.602 V 4065.3 H 9388.8 Z"
}));

var _ref46 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath502",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path500",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref47 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath508",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path506",
  d: "m 8668.8,580.5 h 734.398 V 3719.7 H 8668.8 Z"
}));

var _ref48 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath520",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path518",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref49 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath526",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path524",
  d: "m 8308.8,930.902 h 374.398 v 2438.4 H 8308.8 Z"
}));

var _ref50 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath538",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path536",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref51 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath544",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path542",
  d: "m 7593.6,1967.7 h 729.598 v 710.402 H 7593.6 Z"
}));

var _ref52 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath556",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path554",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref53 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath562",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path560",
  d: "m 10104,1967.7 h 374.398 v 710.402 H 10104 Z"
}));

var _ref54 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath574",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path572",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref55 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath580",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path578",
  d: "m 7953.6,1276.5 h 369.598 v 705.602 H 7953.6 Z"
}));

var _ref56 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath592",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path590",
  d: "m 9300,588.902 v 0 L 7600,2348.9 l 82.06,59.01 H 10323.9 L 9300,588.902 M 10630.5,2952.73 H 8439.79 l 1159.85,833.96 h 1207.56 c 27.5,0 50,22.51 50,50 v 340 c 0,27.51 -22.5,50.01 -50,50.01 h -595.6 l 458.9,330 h 136.7 c 27.5,0 50,22.5 50,49.99 v 84.19 l 1048.3,753.79 v -226.85 l -1275,-2265.09"
}));

var _ref57 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath598",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path596",
  d: "m 9388.8,580.5 h 369.602 v 710.402 H 9388.8 Z"
}));

var _ref58 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath610",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path608",
  d: "M 10027.1,0 H 9463.48 L 9300,588.902 10027.1,0 M 9300,588.902 v 0"
}));

var _ref59 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath622",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path620",
  d: "M 11905.5,0 H 10027.1 L 9300,588.902 10323.9,2407.91 h 433.3 c 55,0 100,44.99 100,99.99 v 344.83 c 0,55 -45,100 -100,100 h -126.7 l 1275,2265.09 V 0"
}));

var _ref60 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath634",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path632",
  d: "m 9300,588.902 v 0 m 0,0 -3200,10 L 7250,2138.9 9300,588.902"
}));

var _ref61 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath646",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path644",
  d: "m 9300,588.902 v 0 m 0,0 -2050,1549.998 350,210 1700,-1759.998"
}));

var _ref62 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath658",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path656",
  d: "m 4320,4598.9 v 0 l -640,1750 1460,-1440 -820,-310"
}));

var _ref63 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath670",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path668",
  d: "m 5140,4908.9 v 0 l -1460,1440 1990,-440 -530,-1000"
}));

var _ref64 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath682",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path680",
  d: "m 5330,4398.9 -1010,200 820,310 190,-510"
}));

var _ref65 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath694",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path692",
  d: "m 5330,4398.9 v 0 l -190,510 530,1000 -340,-1510"
}));

var _ref66 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath706",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path704",
  d: "M 800.516,0 H 0 V 341.973 L 730,658.902 800.516,0"
}));

var _ref67 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath718",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path716",
  d: "M 1388.9,0 H 800.516 L 730,658.902 1388.9,0"
}));

var _ref68 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath730",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path728",
  d: "m 5850,3158.9 -99.09,4.44 v 4.43 l 99.09,-8.87 m -119.08,5.33 -550.92,24.67 v 30 l 550.92,-49.34 v -5.33"
}));

var _ref69 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath742",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path740",
  d: "m 5850,3158.9 -99.09,8.87 v 227.41 L 5850,3158.9 m -119.08,10.66 -550.92,49.34 150,1180 400.92,-956.03 v -273.31"
}));

var _ref70 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath754",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path752",
  d: "m 6100,598.902 -920,2589.998 550.92,-24.67 v -711.15 h 19.99 v 710.26 L 5850,3158.9 6100,598.902"
}));

var _ref71 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath766",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path764",
  d: "m 5850,3158.9 v 0 l -99.09,236.28 V 4770.87 L 7910,6678.9 5850,3158.9 M 5730.92,3442.87 5330,4398.9 5730.92,4753.2 V 3442.87"
}));

var _ref72 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath778",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path776",
  d: "m 6100,598.902 v 0 L 5850,3158.9 7250,2138.9 6100,598.902 M 5850,3158.9 v 0"
}));

var _ref73 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath790",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path788",
  d: "m 7250,2138.9 v 0 l -1400,1020 1273.47,-589.44 v -61.56 c 0,-55 45,-99.99 100,-99.99 h 249.05 l 127.48,-59.01 -350,-210 m -1400,1020 v 0"
}));

var _ref74 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath802",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path800",
  d: "m 7600,2348.9 v 0 l -127.48,59.01 h 131.7 L 7600,2348.9 M 7123.47,2569.46 5850,3158.9 7910,6678.9 7789.56,4996.69 h -616.09 c -27.5,0 -50,-22.49 -50,-50 v -340 c 0,-27.49 22.5,-49.99 50,-49.99 h 584.59 l -23.62,-330 h -560.97 c -27.5,0 -50,-22.5 -50,-50.01 v -340 c 0,-27.49 22.5,-50 50,-50 h 529.47 l -59.71,-833.96 h -419.76 c -55,0 -100,-45 -100,-100 v -283.27 m 100.01,1007.23 c -27.5,0 -50,-22.49 -50,-49.99 v -121.03 c 0,-27.5 22.5,-50 50,-50 h 121.03 c 27.5,0 50,22.5 50,50 v 121.03 c 0,1.13 -0.04,2.26 -0.12,3.38 l 17.81,15.01 -18.07,-12.27 c -3.04,24.64 -24.2,43.87 -49.62,43.87 h -121.03"
}));

var _ref75 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath814",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path812",
  d: "M 10670.5,4556.7 H 7758.06 l 31.5,439.99 h 3017.64 c 27.5,0 50,-22.49 50,-50 v -255.81 l -186.7,-134.18"
}));

var _ref76 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath826",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path824",
  d: "m 10807.2,4556.7 h -136.7 l 186.7,134.18 v -84.19 c 0,-27.49 -22.5,-49.99 -50,-49.99"
}));

var _ref77 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath838",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path836",
  d: "m 7758.06,4556.7 h -584.59 c -27.5,0 -50,22.5 -50,49.99 v 340 c 0,27.51 22.5,50 50,50 h 616.09 l -31.5,-439.99"
}));

var _ref78 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath850",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path848",
  d: "m 9599.64,3786.69 h -1896.7 l 31.5,440.01 h 2477.16 l -611.96,-440.01"
}));

var _ref79 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath862",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path860",
  d: "M 10807.2,3786.69 H 9599.64 l 611.96,440.01 h 595.6 c 27.5,0 50,-22.5 50,-50.01 v -340 c 0,-27.49 -22.5,-50 -50,-50"
}));

var _ref80 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath874",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path872",
  d: "m 7702.94,3786.69 h -529.47 c -27.5,0 -50,22.51 -50,50 v 340 c 0,27.51 22.5,50.01 50,50.01 h 560.97 l -31.5,-440.01"
}));

var _ref81 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath964",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path962",
  d: "m 7394.39,3530.08 c -0.06,0.92 -0.15,1.83 -0.26,2.74 l 18.07,12.27 -17.81,-15.01"
}));

var _ref82 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath976",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path974",
  d: "m 7223.19,3385.89 -6.36,15.8 -26.16,65.02 28.29,9.99 15.87,-52.02 159.3,108.14 c 0.11,-0.91 0.2,-1.82 0.26,-2.74 l -159.04,-133.95 -12.16,-10.24"
}));

var _ref83 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1016",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1014",
  d: "m 7682.06,2407.91 h -77.84 l 39.01,544.82 h 796.56 l -757.73,-544.82"
}));

var _ref84 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1028",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1026",
  d: "M 10323.9,2407.91 H 7682.06 l 757.73,544.82 h 2190.71 l -306.6,-544.82"
}));

var _ref85 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1040",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1038",
  d: "m 10757.2,2407.91 h -433.3 l 306.6,544.82 h 126.7 c 55,0 100,-45 100,-100 V 2507.9 c 0,-55 -45,-99.99 -100,-99.99"
}));

var _ref86 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1052",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1050",
  d: "m 7472.52,2407.91 h -249.05 c -55,0 -100,44.99 -100,99.99 v 61.56 l 349.05,-161.55"
}));

var _ref87 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1064",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1062",
  d: "m 7604.22,2407.91 h -131.7 l -349.05,161.55 v 283.27 c 0,55 45,100 100,100 h 419.76 l -39.01,-544.82"
}));

var _ref88 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1082",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1080",
  d: "m 5730.92,5929.84 v 91.8 h 19.99 v -84.93 l -19.99,-6.87"
}));

var _ref89 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1094",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1092",
  d: "m 5730.92,4753.2 v 1176.64 l 19.99,6.87 V 4770.87 l -19.99,-17.67"
}));

var _ref90 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1106",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1104",
  d: "m 5750.91,3163.34 -19.99,0.89 v 5.33 l 19.99,-1.79 v -4.43"
}));

var _ref91 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1118",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1116",
  d: "m 5750.91,3167.77 -19.99,1.79 v 273.31 l 19.99,-47.69 v -227.41"
}));

var _ref92 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1130",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1128",
  d: "m 5750.91,2453.08 h -19.99 v 711.15 l 19.99,-0.89 v -710.26"
}));

var _ref93 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1142",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1140",
  d: "m 5750.91,3395.18 -19.99,47.69 V 4753.2 l 19.99,17.67 V 3395.18"
}));

var _ref94 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-180.39284,-93.474931)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.35277777,0,0,-0.35277777,-349.08139,247.99612)",
  id: "g10"
}, /*#__PURE__*/React.createElement("g", {
  id: "g850",
  transform: "translate(-1242.9779,-1718.9086)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g854"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1952.3926,1595.4409)",
  id: "g10-5"
}, /*#__PURE__*/React.createElement("image", {
  transform: "scale(1,-1)",
  width: 66.75,
  height: 75,
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABkCAYAAADt75zcAAAABHNCSVQICAgIfAhkiAAAAAlwSFlz AAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAYJSURB VHic7Z1vqJ5lHcc/v2dzzG0OteV0S+ecmbZpKJS5ZZlaKIqIEdEL/yBC+EplYBERRBCjgl71okCj jBhI2j/KQLI0AgcqopMxJ1NMZ3/AcEed7sxPL+4zz3bc2TnnOb/rvu/n3v2Bvdh5Hr73dX+4uJ77 ua7fdT1BC1FPBj4LfAo4B/gYsAJYAiwH3gDeAv4D7Jz49zjwaES83kSbRwJ1pXqnuk094HCMq4+r d6inNH1PrUE9X/2Vun9IsdOxX/2luqHpe2wM9XT1fvW9ZLlTeU/dqn6k6XuuDXWgblbHCsudyl71 LjWadlAU9cPqH2uWO5WH1VObdlEEdb36csOCD/KSel5d9z6o4yLqRuBRoC3j4hnAY+qn67hY8fFJ vQD4G3Bi6WsNwRvAZRHxVMmLFJWsrgP+AbT5mfU1YGNE7C51gWKS1cVUgi8sdY1EngYuiYi3S4SX HJN/xGgIBvgE8P1S4UV6snop1Tg8Ss+kApdHxF+zg9MlqIuAp4CPZ2fXwHbgwojYnxlaYri4ldEU DLAeuCk7NLUnqwuAHcDZmbk18wJwbkSMZwVm9+QvM9qCAdYB12cGZku+JTmvKW7ODEsbLtTTgJeB BVmZDTIOrI6If2eEZfbkq+iGYICFwBezwjIlfz4xqw1cnhWUKXlTYlYb+ExWUMqYrB4PjFHT1GlN HACWRcS++QZlSfloYlZbWACclRGUJWZVUk7bWJ0RkiX5hKSctrE8IyRL8tKknLaxLCMkS3KRye4W kHJfWZL/l5TTNlLq6nrJR6dVkv+ZlNM2XskIyZwg2gN0qTJnT0SkPJpmfoEoWrvQAE9mBWVK3paY 1QbS7idT8oOJWW0g7X6y1/h2UG09GHV2RkTafWRP6tyfnNcUWzPDsnvySmA3cHxmbs3sA86KiD1Z gak9OSL+Bfw8M7MB7s0UDGUqiNYCzwGLs7NrYB9wXkS8mBmaPtE+UYL6vezcmvhutmAoV3C4iOph fn2J/EI8C1yUXQcHhZaMIuJdqgKRea+P1cTbwM0lBEPBdbmIeAK4rVR+IgK3RUTa1+jaUbfUvrdp bozq58ckaqg/bNrkNPzALm2eVL/etNEpbGnaSRHUG61/u+9U3lJH4bNieKx2pm5vSPB2dVR3AcwN dan6SM2CH1G7WrowibpK/Za6u2bBB9k9cf3uVTypF6sPmn9wyLDsVx9QL27azbxRN6oPNetzRv6k XtK0qzmjrlZ/YflTWTL5vbqmaXczoi5Uv6m+2ayvoRlTv6EuzPSSWXexFriPblTcbwNujIidGWEp E0TqrcAzdEMwVOfRPaHekhE2L8lWw8MW4B66Vz67DPiZ+hP1uPkEDT1cWJ1C+ADwufk0YET4C/Cl iBiqsHIoyVar0n+mOifiWGE78IVhFlnnLFk9HXiY6gzNY40dwJURMadqzzlJVlcAf6cbVULDsgvY NJctwbP+4FOXAL/j2BYM1SkIf1BnvZ9kVpKtzrH4NTB6Xz/L8Elgqzorf7Ptyd+h2qDeM8k1wLdn 88YZx2T1WuC3dG/HaQYCN0TEb472pqNKtjo49FngQ4kN6xr/BTZM1AEekZl654/pBc/ECuCnR3vD tJLVrwI3ZLeoo1ynfmW6F484XEw8nuwETivVqg7yKnBORLw59YXpevLd9ILnyipg85Fe+EBPVldT 9eIlhRvVRcaoevNh8xtH6smb6QUPyzLgrql/PKwnqycBL9Hd8yvqYC9wxqHTolN78u30gufLCcDX Dv3D+z3ZqrrxBWBtzY3qIi9S7aASDu/Jl9ELzuJM4NKD/zlUcur5lD2TPgOqBVGqXwRr4y8ojCqv A6dExPjBnryJXnA2J1GVFrw/XFzdXFs6zdUwKfmKBhvSZa4ECKuNjXuBRc22p5PsA5YPgAvoBZdi MbBhwOj84MqoctGA0T/ov+2sGwDtL3webdb0ksuzZgCsbLoVHefUAd2rK24bSwf0qyClWRrqON35 fZA2cmAAvNt0KzrOOwOqFdaecoz1ksuzd0A1OdRTjrEBkHqaX88HeHUAPN90KzrO873k8uzqJZdn 1/8Bc3l/BO7G5noAAAAASUVORK5CYII= ",
  id: "image3144",
  x: 791.45715,
  y: -561.48053
}))))));

var SvgPersonFullIcon = function SvgPersonFullIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 23.547916 26.458332",
    height: "26.458332mm",
    width: "23.547916mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient26",
    spreadMethod: "pad",
    gradientTransform: "matrix(6956.41,0,0,-6956.41,5922.75,7179.75)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    cy: 0,
    cx: 0,
    fy: 0,
    fx: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop22",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop24",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#3a7dc9"
    }
  })), _ref5, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient42",
    spreadMethod: "pad",
    gradientTransform: "matrix(6956.41,0,0,-6956.41,5922.75,7179.75)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    cy: 0,
    cx: 0,
    fy: 0,
    fx: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#3a7dc9"
    }
  })), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient982",
    spreadMethod: "pad",
    gradientTransform: "matrix(221.53,0,0,-221.53,7190.67,3465.49)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop978",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#619a8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop980",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#629a8d"
    }
  })), _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93), _ref94);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonFullIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person_full_icon.f0a671e9.svg";
export { ForwardRef as ReactComponent };